import { type CheckOptions, focusable, isFocusable } from 'tabbable';

const moveFocus = ($target: HTMLElement, options?: CheckOptions): void => {
  if (isFocusable($target, options)) {
    $target.focus({
      preventScroll: true,
    });
  } else {
    const $$focusable = focusable($target, options);

    $$focusable[0]?.focus({
      preventScroll: true,
    });
  }
};

export default moveFocus;
